import { make, debounce } from "./utils";

export default class Ui {
  constructor({ data, api, blockAPI, config, onSelectFile, readOnly, tunes }) {
    this.data = data;
    this.api = api;
    this.blockAPI = blockAPI;
    this.config = config;
    this.onSelectFile = onSelectFile;
    this.readOnly = readOnly;
    this.tunes = tunes;
    this.input = null;
    this.wrapper = make("div", [this.CSS.baseClass, this.CSS.wrapper]);
  }

  get CSS() {
    return {
      baseClass: this.api.styles.block,
      loading: this.api.styles.loader,
      input: this.api.styles.input,
      button: this.api.styles.button,

      /**
       * Tool's classes
       */
      wrapper: 'stored-image',
      imageContainer: 'stored-image__image',
      imagePreloader: 'stored-image__image-preloader',
      imageEl: 'stored-image__image-picture',
      caption: 'stored-image__caption',
    };
  };

  render(data) {
    if(data.file && data.file.url !== '') {
      // Image shown
      this._showImage(this.wrapper);
    } else {
      // Image search shown
      this.wrapper.innerHTML = "";
      const searchWrapper = make("div", "search-wrapper");
      const label = make("label");
      label.innerHTML = "Search: ";

      const input = make("div", "input", { contentEditable: true });
      input.addEventListener("input", debounce(this._searchInput.bind(this)));
      this.input = input;
      searchWrapper.appendChild(label);
      searchWrapper.appendChild(input);

      const imagesWrapper = make("div", "images-wrapper");

      this.wrapper.appendChild(searchWrapper);
      this.wrapper.appendChild(imagesWrapper);
    }
    return this.wrapper;
  }

  _searchInput(e) {
    const wrapper = e.target.parentElement.parentElement; // .stored-image
    const qry = e.target.innerText;
    const url = this.config.apiUrl + "?query=" + qry;
    const imagesWrapper = wrapper.querySelector(".images-wrapper");
    const requestOptions = {
      headers: {
        'Accept': "application/json"
      },
    };
    fetch(url, requestOptions)
        .then((res) => {
          return res.json();
        })
        .then((json) => {
          if (json.images.length > 0) {
            imagesWrapper.innerHTML = "";
            for (const m of json.images) {
              const imageWrapper = make("div", "image-wrapper");
              const image = make("img", "thumbnail", {
                src: m.thumb,
                width: "150",
                height: "150",
              });

              image.addEventListener(
                  "click",
                  function (event) {
                    this.data.alias = m.alias;
                    this.data.file = {
                      alias: m.alias,
                      url: m.large
                    }
                    this._showImage(wrapper, m.large);
                  }.bind(this)
              );
              const caption = make("div", "image-caption", { title: m.name });
              caption.innerHTML = m.name;
              imageWrapper.appendChild(image);
              imageWrapper.appendChild(caption);
              imagesWrapper.appendChild(imageWrapper);
            }
          } else {
            imagesWrapper.innerHTML = "No Images";
          }
        })
        .catch((ret) => {
          imagesWrapper.innerHTML = `${ret}`;
        });
  }

  _showImage(wrapper) {
    wrapper.innerHTML = "";
    this.input = null;
    const image = make("img", "image", {
      src: this.data.file.url,
      style: "min-height: 50px;",
    });
    const captionInput = make("div", "input");
    captionInput.contentEditable = true;
    captionInput.innerHTML = this.data.caption;
    wrapper.appendChild(image);
    wrapper.appendChild(captionInput);

    this._acceptTuneView(wrapper);
  }

  _toggleTune(tune) {
    this.data[tune] = !this.data[tune];
    this._acceptTuneView(this.wrapper);
  }

  _acceptTuneView(wrapper) {
    this.tunes.forEach((tune) => {
      wrapper.classList.toggle(tune.name, !!this.data[tune.name]);

      if (tune.name === 'stretched') {
        /**
         * Wait until the API is ready
         */
        Promise.resolve().then(() => {

          this.blockAPI.stretched = !!this.data.stretched;
        })
            .catch(err => {
              console.error(err);
            });
      }
    });
  }

  _reset(data = {}) {
    this.data = data;
    Promise.resolve().then(() => {
      this.blockAPI.stretched = false;
    })
        .catch(err => {
          console.error(err);
        });
  }
  setFocus() {
    if (this.input !== null) this.input.focus()
  }
}